import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface FieldProps {
	label: string;
	value?: string;
}

export function Field({ label, value }: Readonly<FieldProps>) {
	return (
		<Col span={24}>
			<S.Label>{I18n.get(label)}:</S.Label>
			<S.Value>{value ? value : 'N/A'}</S.Value>
		</Col>
	);
}
